/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type FilterConditionDto = {
    type: FilterConditionDto.type;
};

export namespace FilterConditionDto {

    export enum type {
        SOURCE = 'SOURCE',
        TAG = 'TAG',
        DATASET_NAME = 'DATASET_NAME',
        ASSET = 'ASSET',
        RULE_TEMPLATE_NAME = 'RULE_TEMPLATE_NAME',
        CRITICALITY = 'CRITICALITY',
        DATA_PRODUCT = 'DATA_PRODUCT',
    }


}
